import { Elm } from "./Main.elm";
import axios from "axios";
import { BlockchainMode, Client } from "@hiveio/dhive";

const baseUrl = "https://podcastindex-proxy.herokuapp.com/api/1.0";

let app: Elm.Main.App;

let validAccounts = ["podping"];

document.addEventListener("DOMContentLoaded", function () {
  app = Elm.Main.init({
    flags: null,
  });
  try {
    const addressList = [
      "https://api.openhive.network",
      "https://api.hive.blog",
      "https://hive.roelandp.nl",
      "https://techcoderx.com",
      "https://api.hivekings.com",
      "https://anyx.io",
      //   "https://api.deathwing.me",
      "https://hive-api.arcange.eu",
      "https://rpc.ecency.com",
      "https://hived.privex.io",
    ];
    const address =
      addressList[Math.floor(Math.random() * (addressList.length - 1))];
    console.log(
      `Using endpoint "${address}". If not loading, refresh page to select a different address`
    );
    const client = new Client(address);

    client.database
      .call("get_following", [validAccounts[0], null, "blog", 10])
      .then(function (followers) {
        for (let follower of followers) {
          validAccounts = validAccounts.concat(follower.following);
        }
      })
      .then(function () {
        // can pass the block number to start searching from. By default, uses the current block
        // note: using mode BlockchainMode.Latest does not seem to return data using `getOperationsStream`
        client.blockchain
          .getOperationsStream({ mode: BlockchainMode.Irreversible })
          .on("data", handlePost);
      });
  } catch (e) {
    console.log("Error while intiating hive stream", e);
    alert(
      "Something went wrong while initiation hive stream. The site will no reload"
    );
    document.location.reload();
  }
});

interface Update {
  id: number;
  feedUrl: string;
  imageUrl: string;
  title: string;
  description: string;
  author: string;
  ownerName: string;
  language: string;
  country: string;
}

const getUpdate = async (feedUrl: string): Promise<Update> => {
  try {
    const {
      data: { feed: podcast },
    } = await axios
      .get<any>(`${baseUrl}/podcasts/byfeedurl?url=${feedUrl}&max=1`)
      .then((res) => {
        console.log(res.status, res.statusText, res.data);
        return res;
      })
      .catch((err) => {
        console.error(`Getting ${feedUrl} failed`, err);
        return null;
      });
    if (!podcast) {
      console.error("Could not get podcast for ", feedUrl);
      return null;
    }
    const update = {
      id: podcast.id,
      feedUrl,
      imageUrl: podcast.artwork || podcast.image,
      title: podcast.title,
      description: podcast.description,
      author: podcast.author,
      ownerName: podcast.ownerName,
      language: podcast.language,
      country: podcast.language?.split("-")?.[1],
    };
    console.log("podcast Data", podcast);
    console.log("update Data", update);
    if (update.imageUrl) {
      return update;
    } else {
      console.error("Could not load image for ", podcast);
    }
  } catch (e) {
    console.error("Error while getting feed image", e);
  }
};

// const mockFeeds = [
//   "https://www.theincomparable.com/imgs/logos/logo-batmanuniversity-3x.jpg?cache-buster=2019-06-11",
// ];

let feeds = [];

const removeFeed = (title) => feeds.filter((t) => t !== title);

function handlePost(post) {
  let operationType = post.op[0];
  if (operationType !== "custom_json") return;

  let operation = post.op[1];
  if (operation.id !== "podping") return;

  let postJson = JSON.parse(operation.json);

  let postingAuths = new Set(operation.required_posting_auths);

  // check if valid user
  let accounts = new Set(validAccounts);
  let intersect = new Set();
  for (let x of accounts) {
    if (postingAuths.has(x)) intersect.add(x);
  }
  if (intersect.size === 0) return;

  let block = post.block;
  let timestamp = post.timestamp;
  let trx_id = post.trx_id;

  const message = `Feed updated - ${timestamp} - ${block} - ${trx_id} - ${postJson["urls"]}`;
  console.log(message);

  try {
    const urlArr = Array.isArray(postJson.urls)
      ? postJson.urls
      : [postJson.urls];

    urlArr.forEach((url) => {
      console.log("FEED", url);
      getUpdate(url).then((update: Update) => {
        if (!update) {
          console.error("No update for ", url);
          return;
        }
        console.log("FEED-IMAGE", update.imageUrl);
        feeds.push(update.title);
        console.log("### Loading image", update.title, update.imageUrl);
        const imgObj = new Image();
        imgObj.src = update.imageUrl;
        imgObj.onload = () => {
          feeds = removeFeed(update.title);
          console.log("### Sending to Elm", update.title, update.imageUrl);
          app.ports.updateFromJsToElm.send(update);
          console.log("Feeds not send: ", feeds);
        };
      });
    });
  } catch (e) {
    console.log("Error while getting results from hive stream", e);
  }
}
